import script from "./ProductItem.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductItem.vue?vue&type=script&setup=true&lang=js"

import "./ProductItem.vue?vue&type=style&index=0&id=705cc8be&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-705cc8be"]])

export default __exports__